export const testimonials = [
  {
    quote:
      "Je passais mes dimanches soirs à préparer mes cours de la semaine. Maintenant j'imprime, je range dans le classeur et c'est réglé. J'ai récupéré au moins 5 heures par semaine.",
    name: 'Julien M.',
    role: 'Professeur de guitare, Lyon',
  },
  {
    quote:
      "Le volume sur le ii-V-I a débloqué trois de mes élèves qui stagnaient depuis des mois. La progression tonalité par tonalité est d'une clarté incroyable.",
    name: 'Claire D.',
    role: 'École de musique, Bordeaux',
  },
  {
    quote:
      "Mes élèves adultes adorent le guide de survie en jam. Deux d'entre eux sont montés sur scène le mois dernier pour la première fois.",
    name: 'Marc-André L.',
    role: 'Guitariste et pédagogue, Montréal',
  },
];
